import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    root: {
        display: 'grid',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    input: {
        flex: 1,
        margin: theme.spacing(1)
    },
    row: {
        display: 'flex',
        alignItems: 'center',
    },
    switch: {
        margin: theme.spacing(1, 2)
    },
    textarea: {
        display: 'grid',
        gap: theme.spacing(1)
    },
    paper: {
        padding: theme.spacing(2),
        width: '100%',
        display: 'block',
        marginBottom: theme.spacing(2),
    },
    rootFab: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        }
    },
    container: {
        display: 'flex',
        justifyContent: "flex-end",
    },
    modal: {
        display: 'flex',
        flexDirection: 'column',
    },
    buttons: {
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(2)
    },
    fab: {
        margin: `0px ${theme.spacing(1)}`
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    }
}));

export default useStyles;